import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type AuthState = {
  isAuth: boolean;
  redirectUrl: string | null;
};

const initialState: AuthState = {
  isAuth: false,
  redirectUrl: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated: (state, action: { payload: boolean }) => {
      state.isAuth = action.payload;
    },

    setRedirectUrl: (state, action: PayloadAction<string | null>) => {
      state.redirectUrl = action.payload;
    },
  },
});

export const { setAuthenticated, setRedirectUrl } = authSlice.actions;
export default authSlice.reducer;
